import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { SharedModule } from "src/app/shared/shared.module";
import { CnaePermitidoRoutingModule } from "./cnae-permitido-routing.module";
import { CnaePermitidoPesquisaComponent } from "./pesquisa/cnae-permitido-pesquisa.component";
import { CnaePermitidoListagemComponent } from "./pesquisa/listagem/cnae-permitido-listagem.component";
import { NgSelectModule } from '@ng-select/ng-select';
import { NovoCnaePermitidoComponent } from "./pesquisa/novo/novo-cnae-permitido.component";

@NgModule({
  declarations: [
    CnaePermitidoPesquisaComponent,
    CnaePermitidoListagemComponent,
    NovoCnaePermitidoComponent
  ],
  imports: [ 
    SharedModule,
    BrowserModule,
    CommonModule,
    CnaePermitidoRoutingModule,
    NgSelectModule
  ],
})
export class CnaePermitidoModule { }